// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Aurora-Dia--tips > span {\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  padding: 0 0.05rem;\n  color: #7aa2f7;\n  background-color: #7aa2f7;\n  background-image: var(--strong-gradient);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
